<template>
  <div class="block">
    <el-carousel indicator-position="none" class="el-image-sy" height="100%">
      <el-carousel-item class="el-image-item hh" v-for="item in itemData.imgList" :key="item.id" @change="changeItem(item)">
        <img :src="item.src" alt="" class="image">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<style scoped>
.block{
  width: 100%;
  height: 100%;
}
.hh{
  height: 100%;
}
.image {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  /*锁定图片的长宽比 */
}
.el-image-sy{
  width: 100%;
  aspect-ratio: 1920/860;
}
.el-image-item{
  width: 100%;
  height: 100%;
}
.el-carousel__container {
  height: 100%;
}
</style>
<script>
import {Data} from "../js/image/image";

export default {
  name: 'img',
  data() {
    return {
      dataAll: Data,
      itemData: {},
    }
  },
  mounted() {
    let that = this;
    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.$parent.message == itemData.type){
        that.itemData = itemData;
        break;
      }
    }
  },
  methods: {
    //切换轮播图
    changeItem() {

    }
  }


}
</script>



// WEBPACK FOOTER //
// src/components/image/image.vue